import styled from 'styled-components';

export const Body = styled.div`
  margin-top: ${props => props.theme.spacing.s16};
`;
